import React from "react";
import { EmployeeStatusContainer } from "../../containers";

const EmployeeStatus = (props) => {
  return <EmployeeStatusContainer {...props} />;
};

export default EmployeeStatus;
